var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fb-share-button",attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":require("../../../assets/images/f_logo_RGB-Blue_72.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }